import { useState, useCallback, useEffect } from "react";
const useContextMenu = (targetId,ref) => {

  const [xPos, setXPos] = useState("-1000px");
  const [yPos, setYPos] = useState("-1000px");
  const [showMenu, setShowMenu] = useState(false);
  const targetIdElement = document.getElementById(targetId)
  const handleContextMenu = useCallback(
    (e) => {
      if(targetIdElement?.contains(e.target)){
        e.preventDefault();
        let positionX =e.pageX;
        let positionY =e.pageY;
        setShowMenu(true);
        
        //Fixed Overflow of Context Menu from Screen;
        setTimeout(()=>{
          const targetContainer = document.getElementById(targetId);
          const windowWidth  = window.innerWidth || document.documentElement.clientWidth  || document.body.clientWidth;
          const windowHeight = window.innerHeight|| document.documentElement.clientHeight || document.body.clientHeight;
          const contentWidth =  document.getElementById("commonContextMenu")?.offsetWidth || targetContainer?.offsetWidth;
          const contentHeight=  document.getElementById("commonContextMenu")?.offsetHeight|| targetContainer?.offsetHeight;          
          let newContextMenuPositionX=positionX;
          let newContextMenuPositionY=positionY;

          if((positionX + contentWidth) > windowWidth){
            const diff =(positionX + contentWidth) - windowWidth ;
            newContextMenuPositionX = positionX - diff;
          }
          if((positionY + contentHeight) > windowHeight){
            const diff =(positionY + contentHeight) - windowHeight ;
            newContextMenuPositionY = positionY - diff;
          }

          setXPos(`${newContextMenuPositionX}px`)
          setYPos(`${newContextMenuPositionY}px`)
          
        },0)
      }
      
    },
    [setXPos, setYPos, targetIdElement]
  );

  const handleClick = useCallback(() => {
    if (showMenu) {
      setXPos("-1000px");
      setYPos("-1000px");
      setShowMenu(false);
    }
  }, [showMenu]);

  const handleMouseMove = (e) => {
    let positionX =e.pageX;
    let positionY =e.pageY;
    // console.log("positionX: ", positionX);
    // console.log("positionY: ", positionY);
  }
  useEffect(() => {
    
    //page needs default context menu functionality, find another solution for this.
    //uncommenting till the time solution is merged in this branch
    document.body.addEventListener("click", handleClick);
    document.body.addEventListener("contextmenu", handleContextMenu);
    document.body.addEventListener("mousemove", handleMouseMove);
    return () => {
      document.body.removeEventListener("click", handleClick);
      document.body.removeEventListener("contextmenu", handleContextMenu);
      document.body.removeEventListener("mousemove", handleMouseMove);
    };
  });

 

  const closeMenu = useCallback(() => {
    setXPos("-1000px");
    setYPos("-1000px");
    setShowMenu(false);
  }, []);

  return { xPos, yPos, showMenu, closeMenu };
};
export default useContextMenu;